<template>
 <fieldset>
     <legend>{{title}}</legend>
     <slot></slot>
 </fieldset>
</template>
<script>
export default {
 // 说明：仅仅写UI组件库的时候才有用，平时相对没用
 // 目的：后期调用语法
 name: 'qfui-kuangkuang',
 props: {
     title: {
         type: String
     }
 },
}
</script>
<style scoped>
</style>